import { useParams } from "react-router-dom";
import { SubCategoryForm } from "./components/SubCategoryForm";
import { subCategoryService } from "@/frontend/services";
import type { SubCategoryResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateSubCategoryPage() {
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useGetId<SubCategoryResponseDTO>({
    fetchFn: subCategoryService.getById,
    redirectUrl: "/sub-categories",
    errorMessage: "Error al cargar la subcategoría",
    id,
  });

  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }

  if (!data) return null;

  const initialValues = {
    disciplineId: data.disciplineId,
    category: data.category,
    description: data.description || "",
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm w-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Actualizar Subcategoría</h2>
        <p className="text-gray-600 mt-1">
          Modifica la información de la subcategoría
        </p>
      </div>
      <SubCategoryForm subCategoryId={id} initialValues={initialValues} />
    </div>
  );
}
